import BuildIcon from "@mui/icons-material/Build";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import ConstructionIcon from "@mui/icons-material/Construction";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import GroupIcon from "@mui/icons-material/Group";
import HomeIcon from "@mui/icons-material/Home";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import PaymentIcon from "@mui/icons-material/Payment";
import PersonIcon from "@mui/icons-material/Person";
import PlaceIcon from "@mui/icons-material/Place";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import StoreIcon from "@mui/icons-material/Store";
import { Divider, Stack } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { English } from "../../../constant/EnglishFallback";
import {
  setProjectimages,
  setSelectedcompany,
  setSelectedProjectdata,
  setSelectedsite,
  setSelectlocation,
  setShowmapmodal
} from "../../../redux/actions/actions";
import HandshakeIcon from '@mui/icons-material/Handshake';

const drawerWidth = 240;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar
}));
export default function Sidebar(props) {
  const activeRef = useRef("home");
  const location = useLocation();
  const dispatch = useDispatch();

  const { multiLanguageData } = useSelector((state) => state.main);

  const {
    TEXT_HOME = English?.Sidebar?.TEXT_HOME,
    TEXT_SITES = English?.Sidebar?.TEXT_SITES,
    BUTTON_REWARDS_STORE = English?.Sidebar?.BUTTON_REWARDS_STORE,
    TEXT_MY_EXPERIENCE_HEADING = English?.Sidebar?.TEXT_MY_EXPERIENCE_HEADING,
    TEXT_TIMESHEETS = English?.Sidebar?.TEXT_TIMESHEETS,
    TEXT_EXPENSES = English?.Sidebar?.TEXT_EXPENSES,
    RESUME_BUILDER = English?.Sidebar?.RESUME_BUILDER,
    TEXT_TICKETS = English?.Sidebar?.TEXT_TICKETS,
    TEXT_MONTAGES = English?.Sidebar?.TEXT_MONTAGES,
    TEXT_COMMUNITY_HEADING = English?.Sidebar?.TEXT_COMMUNITY_HEADING,
    TEXT_BUILDER_NETWORK = English?.Sidebar?.TEXT_BUILDER_NETWORK,
    TEXT_CARPOOL = English?.Sidebar?.TEXT_CARPOOL,
    TEXT_JOB_POSTINGS = English?.Sidebar?.TEXT_JOB_POSTINGS,
    TEXT_BUY_SELL = English?.Sidebar?.TEXT_BUY_SELL,
    TEXT_MY_GROUPS = English?.Sidebar?.TEXT_MY_GROUPS,
    TEXT_COMPANIES = English?.Sidebar?.TEXT_COMPANIES,
    TEXT_MANUFACTURERS = English?.Sidebar?.TEXT_MANUFACTURERS,
    TEXT_PRODUCTS = English?.Sidebar?.TEXT_PRODUCTS,
    TEXT_TRADES_TITLE = English?.Sidebar?.TEXT_TRADES_TITLE,
    TEXT_COMMUNITY = English?.Sidebar?.TEXT_COMMUNITY
  } = multiLanguageData?.Sidebar || {};

  useEffect(() => {
    const currentPath = location.pathname.split("/")[1] || "home"; // Get the active menu from the URL
    activeRef.current = currentPath; // Update the activeRef
  }, [location]);

  const firstMenu = [
    {
      path: "/home",
      icon: <HomeIcon className="menu-icons" />,
      title: "Home",
      forTranslate: TEXT_HOME
    },
    {
      path: "/community",
      icon: <GroupIcon className="menu-icons" />,
      title: "CommunityHome",
      forTranslate: TEXT_COMMUNITY_HEADING
    },
    {
      path: "/sites",
      icon: <PlaceIcon className="menu-icons" />,
      title: "Sites",
      forTranslate: TEXT_SITES
    },
    {
      path: "/reward-store",
      icon: <StoreIcon className="menu-icons" />,
      title: "Rewards Store",
      forTranslate: BUTTON_REWARDS_STORE
    }
  ];

  const secondMenu = [
    {
      path: "/timesheets",
      icon: <InsertInvitationIcon className="menu-icons" />,
      title: "Timesheets",
      forTranslate: TEXT_TIMESHEETS
    },
    {
      path: "/expenses",
      icon: <RequestQuoteIcon className="menu-icons" />,
      title: "Expenses",
      forTranslate: TEXT_EXPENSES
    },
    {
      path: "/resume-builder",
      icon: <InsertDriveFileIcon className="menu-icons" />,
      title: "Resume Builder",
      forTranslate: RESUME_BUILDER
    },
    {
      path: "/tickets",
      icon: <PaymentIcon className="menu-icons" />,
      title: "Tickets",
      forTranslate: TEXT_TICKETS
    },
    {
      path: "/montages",
      icon: <PlayCircleOutlineIcon className="menu-icons" />,
      title: "Montages",
      forTranslate: TEXT_MONTAGES
    }
  ];

  const thirdMenu = [
    {
      path: "/contacts",
      icon: <PersonIcon className="menu-icons" />,
      title: "Builder Network",
      forTranslate: TEXT_BUILDER_NETWORK
    },
    {
      path: "/carpool",
      icon: <DirectionsCarIcon className="menu-icons" />,
      title: "Carpool",
      forTranslate: TEXT_CARPOOL
    },
    {
      path: "/job-postings",
      icon: <BusinessCenterIcon className="menu-icons" />,
      title: "Job Postings",
      forTranslate: TEXT_JOB_POSTINGS
    },
    {
      path: "/buy-sell",
      icon: <HandshakeIcon className="menu-icons" />,
      title: "BuySell",
      forTranslate: TEXT_BUY_SELL
    }
  ];

  const fourthMenu = [
    {
      path: "/companies",
      icon: <BusinessCenterIcon className="menu-icons" />,
      title: "Companies",
      forTranslate: TEXT_COMPANIES
    },
    {
      path: "/manufactures",
      icon: <BusinessCenterIcon className="menu-icons" />,
      title: "Manufactures",
      forTranslate: TEXT_MANUFACTURERS
    },
    {
      path: "/products",
      icon: <BuildIcon className="menu-icons" />,
      title: "Products",
      forTranslate: TEXT_PRODUCTS
    },
    {
      path: "/trades",
      icon: <ConstructionIcon className="menu-icons" />,
      title: "Trades",
      forTranslate: TEXT_TRADES_TITLE
    }
  ];

  const navigate = useNavigate();

  const handleDrawerClose = () => {
    props?.setMobileOpen(false);
  };

  const onPageopen = (item, index) => {
    dispatch(setProjectimages([]));
    dispatch(setSelectedsite(null));
    dispatch(setSelectedcompany({}));
    dispatch(setSelectedProjectdata(null));
    let mapModal = {
      open: false,
      from: "",
      select: ""
    };
    dispatch(setShowmapmodal(mapModal));
    let locationModal = {
      open: false,
      lat: 0,
      lng: 0
    };
    dispatch(setSelectlocation(locationModal));
    navigate(item?.path);
    activeRef.current = item.path;
    handleDrawerClose();
  };

  const Menulist = ({ menuName, menuList }) => {
    return (
      <>
        <p className="sidemenu-name">{menuName}</p>
        <List className="sidemenu-list">
          {menuList?.map((item, index) => (
            <ListItem
              key={index}
              disablePadding
              className={`sidemenu-item ${item.path.includes(activeRef.current) ? "active" : ""}`}>
              <ListItemButton className="sidemenu-button" onClick={() => onPageopen(item, index)}>
                <ListItemIcon
                  className="sidemenu-icon"
                  style={{
                    color: item.path.includes(activeRef.current) ? "#083DB8" : ""
                  }}>
                  {item?.icon}
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ className: "sidemenu-text" }}>
                  {item?.forTranslate}
                </ListItemText>
              </ListItemButton>
            </ListItem>
          ))}
          <Divider />
        </List>
      </>
    );
  };

  const drawer = (
    <div>
      <DrawerHeader />
      <Stack>
        <Menulist menuName={""} menuList={firstMenu} />
        <Menulist menuName={TEXT_MY_EXPERIENCE_HEADING} menuList={secondMenu} />
        <Menulist menuName={TEXT_COMMUNITY_HEADING} menuList={thirdMenu} />
        <Menulist menuName={TEXT_MY_GROUPS} menuList={fourthMenu} />
      </Stack>
    </div>
  );

  return (
    <>
      <Drawer
        variant="temporary"
        open={props?.mobileOpen}
        onClose={handleDrawerClose}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": { width: drawerWidth }
        }}>
        {drawer}
      </Drawer>

      <Drawer
        className="sidemenu-drawer"
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            scrollbarWidth: "none"
          },
          display: { xs: "none", sm: "block" }
        }}
        open>
        {drawer}
      </Drawer>
    </>
  );
}

Sidebar.propTypes = {
  window: PropTypes.func
};
